import React from 'react'
import MhCandidateReport from './mhCandidateReport'
import { useParams } from '@pankod/refine-react-router-v6'

// MH scorecards render from Mh_report_card with the TNA-template design (CENTA blue),
// fully independent of the TQ/SKT scorecard component.
const Mh_View_Report = () => {
  let { id } = useParams()
  return <div>{id && <MhCandidateReport candidate={id} />}</div>
}

export default Mh_View_Report
